import { css } from 'aphrodite';
import React from 'react';
import { Button } from '../../../../../components-v2/Button';
import { AddSectionIcon } from '../../../../../components/svgs/icons/AddSectionIcon';
import { styleSheet } from './styles';

/** Props for SectionsActionBar — shared action bar for the survey creation editor. */
export interface SectionsActionBarProps {
	/** Called when the user clicks "+ Add Section". Always rendered. */
	onAddSection: () => void;
	/** When provided, renders a "+ Add Question" button to the left of "+ Add Section". */
	onAddQuestion?: () => void;
	/** Controls whether the "+ Add Section" button is enabled. Defaults to true. */
	canAddSection?: boolean;
	/** Controls whether the "+ Add Question" button is enabled. Defaults to true. */
	canAddQuestion?: boolean;
}

/**
 * SectionsActionBar renders the bottom action bar for the survey-creation editor.
 *
 * Used by both V1 (AdditionalQuestions, onAddSection only) and V2 (QuestionsWithSections,
 * both onAddQuestion and onAddSection).
 */
export const SectionsActionBar: React.FC<SectionsActionBarProps> = ({
	onAddSection,
	onAddQuestion,
	canAddSection = true,
	canAddQuestion = true,
}) => (
	<div className={css(styleSheet.bar)}>
		{onAddQuestion && (
			<Button
				type='button'
				variant='secondary'
				onClick={onAddQuestion}
				disabled={!canAddQuestion}
				styles={[styleSheet.button]}
			>
				+ Add Question
			</Button>
		)}
		<Button
			type='button'
			variant='secondary'
			onClick={onAddSection}
			disabled={!canAddSection}
			styles={[styleSheet.button]}
		>
			<AddSectionIcon className={css(styleSheet.addSectionIcon)} aria-hidden='true' />
			Add Section
		</Button>
	</div>
);
